import { getItemsByContext, getSortedBy, getSearchText, criteriaForUrl, getItemsByContextAndType, } from './helpers'
import { processingValue, processingFilters, } from '../../../utils/filters-pre-processor'
import qs from 'qs'
import { urlSpecialCharEncoder, } from '../../../utils/urlSpecialCharHandlers'

export default {
  criteriaCount: ({ criteria, }) => criteria.length,
  getFields: ({ filters, }) => (context) => filters ? getItemsByContext(filters, context) : [],
  // eslint-disable-next-line max-len
  getFieldsByType: ({ filters, }) => ({ context, type, }) => filters ? getItemsByContextAndType({
    filters,
    context,
    type,
  }) : [],
  simpleSearchFilters: ({ filters, }) => filters ? getItemsByContext(filters, 'FILTER_LEIREC_SIMPLE') : [],
  simpleSearchDropDown: ({ filters, }) => filters ? getItemsByContext(filters, 'FILTER_LEIREC_FULLTEXT') : [],
  searchParams ({
    fulltextFilter, simpleFilters, simpleSearch, sortedBy,
    currentPage, perPage, criteria, expertMode,
  }) {
    const searchText = getSearchText(fulltextFilter, processingValue(simpleSearch))
    return {
      filter: expertMode
        ? processingFilters(criteria)
        : {
          ...simpleFilters,
          [fulltextFilter.field]: searchText,
        },
      sort: getSortedBy(sortedBy),
      page: {
        number: currentPage,
        size: perPage,
      },
    }
  },
  paramsForURL ({
    fulltextFilter, simpleFilters, simpleSearch, sortedBy,
    currentPage, perPage, criteria, expertMode,
  }) {
    const nullOrValue = (value, condition = !expertMode) => condition ? value : null
    const needCriteria = () => {
      return expertMode && criteria.reduce((acc, { value, }) => acc || !!value, false)
    }
    const params = {
      simpleSearch: nullOrValue(simpleSearch, !expertMode && simpleSearch),
      fulltextFilterId: nullOrValue(fulltextFilter.id),
      simpleFilters: nullOrValue(simpleFilters),
      sortedBy: nullOrValue(sortedBy, sortedBy.field),
      criteria: nullOrValue(criteriaForUrl(criteria), needCriteria()),
      currentPage,
      perPage,
      expertMode,
    }
    return qs.stringify(params, {
      skipNulls: true,
      encoder: urlSpecialCharEncoder,
      encodeValuesOnly: true,
    })
  },
  getParamsForExportSearch ({ expertMode, simpleFilters, criteria, fulltextFilter, simpleSearch, total, }) {
    const searchText = getSearchText(fulltextFilter, processingValue(simpleSearch))
    const params = {
      filter: expertMode ? processingFilters(criteria) : {
        ...simpleFilters,
        [fulltextFilter.field]: searchText,
      },
      page: {
        size: (total <= 5000)
          ? total
          : 5000,
      },
    }

    return qs.stringify(params, {
      skipNulls: true,
      encodeValuesOnly: true,
    })
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/search/getters.js